import React from 'react';

const SearchAndFilter = ({
  services,
  resourcedTexts,
  onSubmit,
  searchTerm,
  searchOnChange,
  selectedService,
  serviceOnChange,
}) => {
  return (
    <section className="search-and-filter">
      <form className="search-and-filter__search" onSubmit={onSubmit}>
        <div className="form-field form-field--location-target">
          <input
            type="text"
            className="search"
            placeholder={resourcedTexts.searchPlaceholder}
            name="search"
            title={resourcedTexts.searchPlaceholder}
            aria-describedby="search"
            value={searchTerm}
            onChange={searchOnChange}
            autoComplete="off"
          />
          <label htmlFor="search">{resourcedTexts.searchPlaceLabel}</label>
        </div>

        <div className="form-field">
          <label htmlFor="services" className="visually-hidden">
            {resourcedTexts.searchServiceLabel}
          </label>
          <select
            id="services"
            className="services-filter"
            name="services"
            value={selectedService}
            onChange={serviceOnChange}
          >
            <option value="" disabled hidden>
              {resourcedTexts.searchServicePlaceholder}
            </option>
            <option value="-">{resourcedTexts.searchServiceEmptyOption}</option>
            {services.map((service) => {
              return (
                <option value={service.id} key={service.id}>
                  {service.name}
                </option>
              );
            })}
          </select>
        </div>

        <button className="button" type="submit">
          {resourcedTexts.searchButtonText}
        </button>
      </form>
    </section>
  );
};

export default SearchAndFilter;
